import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import UsersBannedFrom from "./users-banned-from";
import UsersBannedData from "./users-banned-data";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const GetUsersBanned = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <UsersBannedFrom />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UsersBannedData />
    </React.Fragment>
  );
});
export default GetUsersBanned;
